import React from "react";
import logo from "./logo.svg";
import styles from "./site-loader.module.scss";
import { ProgressBar } from "primereact/progressbar";

function SiteLoader() {
  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="HSP" />
      <ProgressBar
        mode="indeterminate"
        color="#188A42"
        style={{ height: 6, width: 300 }}
      ></ProgressBar>
      <p className={styles.text}>Loading your information, please wait.</p>
    </div>
  );
}

export default SiteLoader;
